'use strict';

/**
 * Controlla se un valore è null or undefined
 * Nel caso di array controlla la dimensione
 * Nel caso di oggetto fa un controllo su ogni key dell' oggetto
 *
 * @param val
 * @return {boolean}
 */
export function isEmpty(val) {
  if (val === undefined) {
    return true;
  }

  if (typeof val === 'function' ||
    typeof val === 'number' ||
    typeof val === 'boolean' ||
    Object.prototype.toString.call(val) === '[object Date]') {
    return false;
  }

  if (val === null || val.length === 0) {
    return true;
  }

  if (typeof val === 'object') {
    let r = true;

    for (let f in val) {
      r = false;
    }
    return r;
  }

  return false;
}

/**
 * Calcola l' altezza delle celle della grid
 *
 * @param size
 * @param heightRow
 * @return {number}
 */
export function calculateGridHeight(size, heightRow = 30) {
  if (size == null || size === 0) { return 100; }
  size = (size > 5) ? 5 : size;

  return size * heightRow + 50;
}

/**
 * Verifica se una variabile è di tipo booleano
 *
 * @param val
 * @return {boolean}
 */
export function isBoolean(val) {
  return val === true || val === false || toString.call(val) === '[object Boolean]';
}

/**
 * Rimuove le property null dall oggetto
 *
 * @param obj
 * @return {*}
 */
export function removeNull(obj) {
  Object.keys(obj).forEach(key => {
    let value = obj[key];
    let hasProperties = value && Object.keys(value).length > 0;
    if (value === null) {
      delete obj[key];
    }
    else if ((typeof value !== "string") && hasProperties) {
      removeNullProperties(value);
    }
  });
  return obj;
}

